import { SyncRequestClient } from 'ts-sync-request/dist'

export class ApiClient {

    // async

    static get(url: string) : Promise<Response> {
        return new Promise((resolve, reject) => {
            fetch(url, {
                method: 'GET',
                mode: "cors",
                headers: {
                    Accept: 'application/json',
                },
                credentials: 'include',
            })
            .then(data => resolve(data))
            .catch(err => {
                reject(`Error! status: ${err}`);
            });
        });
    }

    static postWithoutCredentials(url: string, data: any): Promise<Response> {
        return fetch(url, {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        });
    }

    static post(url: string, data: any): Promise<Response> {
        let options: RequestInit = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                Accept: 'application/json',
            },
            credentials: 'include',
        }

        return fetch(url, options);
    }
    static postFile(url:string, data: FormData): Promise<Response>{
         let options: RequestInit ={
            method: 'POST',
            body: data,
            mode: 'cors',
            headers: {
                Accept: 'application/json',
            }
        };
        return fetch(url, options);
    }
    static put(url: string, data: any): Promise<Response>  {
        let options: RequestInit ={
            method: 'PUT',
            body: JSON.stringify(data),
            headers:{
                "Content-Type": 'application/json;charset=UTF-8',
                Accept: 'application/json',
            },
            credentials: 'include',
        };
        
        return fetch(url, options);
    }

    static delete(url: string, data: any) { 
        return fetch(url, {
            method: 'DELETE',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                Accept: 'application/json',
            },
            credentials: 'include',
        });
    }


    // sync

    static getSync(url: string) {
        return new SyncRequestClient().get(url);
    }
}

